import React from "react";
import { lightenColor } from "@/utils/lightenColor";

interface SendCodeIconAttributes {
  className?: string;
  brandingColor?: string;
}

export const EmailSendCodeIcon: React.FC<SendCodeIconAttributes> = ({
  className = "",
  brandingColor = "#22880",
}: SendCodeIconAttributes) => {
  return (
    <svg
      width="74"
      height="64"
      viewBox="0 0 74 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58.5 15H1.5C0.671573 15 0 15.6716 0 16.5V53.5C0 54.3284 0.671571 55 1.5 55H58.5C59.3284 55 60 54.3284 60 53.5V26V16.5C60 15.6716 59.3284 15 58.5 15Z"
        fill={lightenColor(brandingColor, 90)}
      />
      <path
        d="M64.5 9H7.5C6.67157 9 6 9.67157 6 10.5V47.5C6 48.3284 6.67157 49 7.5 49H64.5C65.3284 49 66 48.3284 66 47.5V20V10.5C66 9.67157 65.3284 9 64.5 9Z"
        fill="white"
      />
      <path
        d="M66 20V10.5C66 9.67157 65.3284 9 64.5 9H7.5C6.67157 9 6 9.67157 6 10.5V47.5C6 48.3284 6.67157 49 7.5 49H41"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.832 23.6006L49 26.5293"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.168 23.6006L16 33.0006"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.013 10.3701L39.645 27.8635C37.4508 29.3783 34.5485 29.3783 32.3543 27.8635L6.98633 10.3701"
        fill="white"
      />
      <path
        d="M65.013 10.3701L39.645 27.8635C37.4508 29.3783 34.5485 29.3783 32.3543 27.8635L6.98633 10.3701"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48 39C48 36.7909 49.7909 35 52 35H68C70.2091 35 72 36.7909 72 39V51C72 53.2091 70.2091 55 68 55H52C49.7909 55 48 53.2091 48 51V39Z"
        fill="white"
        stroke={brandingColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60 23C55.5817 23 52 26.5817 52 31V35H68V31C68 26.5817 64.4183 23 60 23Z"
        stroke={brandingColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60 44.0771C59.4477 44.0771 59 44.5249 59 45.0771C59 45.6294 59.4477 46.0771 60 46.0771C60.5523 46.0771 61 45.6294 61 45.0771C61 44.5249 60.5523 44.0771 60 44.0771Z"
        stroke="#5C5C5C"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
